import { call, takeEvery, all, select } from 'redux-saga/effects';

import { RECORD_EVENT_REQUEST } from './constants';
import {
  clubList,
  clubDetail,
  selectClub,
  clubSignupStep,
  clubPurchase
} from './gtmClub';
import {
  viewItemList,
  viewItem,
  selectItem,
  selectPromotion,
  addToCart,
  removeFromCart,
  viewCart,
  checkoutStep,
  purchase
} from './gtmEcommerce';
import {
  reservationAvailabilityList,
  selectReservation,
  reservationCheckoutStep,
  reservationPurchase
} from './gtmReservations';

const getSettings = (state) => state.setting.data;

export function* recordEvent(action) {
  try {
    const settings = yield select(getSettings);
    yield call(record, action.eventName, action.payload, settings.currency);
  } catch (error) {
    // fail silently
    // eslint-disable-next-line no-console
    console.error(error);
  }
}

export const record = (eventName, payload, currency) => {
  switch (eventName) {
    case 'productList': {
      viewItemList(payload, currency);
      break;
    }
    case 'productDetail': {
      viewItem(payload, currency);
      break;
    }
    case 'productClick': {
      selectItem(payload, currency);
      break;
    }
    case 'addCoupon': {
      selectPromotion(payload, currency);
      break;
    }
    case 'addToCart': {
      addToCart(payload, currency);
      break;
    }
    case 'removeFromCart': {
      removeFromCart(payload, currency);
      break;
    }
    case 'viewCart': {
      viewCart(payload);
      break;
    }
    case 'checkoutBegin': {
      checkoutStep(payload, currency, 'begin_checkout');
      break;
    }
    case 'checkoutCustomer': {
      checkoutStep(payload, currency, 'add_customer_info');
      break;
    }
    case 'checkoutDelivery': {
      checkoutStep(payload, currency, 'add_shipping_info');
      break;
    }
    case 'checkoutPayment': {
      checkoutStep(payload, currency, 'add_payment_info');
      break;
    }
    case 'checkoutComplete': {
      purchase(payload, currency);
      break;
    }
    case 'reservationAvailabilityList': {
      reservationAvailabilityList(payload, currency);
      break;
    }
    case 'selectReservation': {
      selectReservation(payload, currency);
      break;
    }
    case 'reservationCheckoutBegin': {
      reservationCheckoutStep(payload, currency, 'begin_reservation_checkout');
      break;
    }
    case 'reservationCheckoutCustomer': {
      reservationCheckoutStep(
        payload,
        currency,
        'add_reservation_customer_info'
      );
      break;
    }
    case 'reservationCheckoutPayment': {
      reservationCheckoutStep(
        payload,
        currency,
        'add_reservation_payment_info'
      );
      break;
    }
    case 'reservationCheckoutComplete': {
      reservationPurchase(payload, currency);
      break;
    }
    case 'clubList': {
      clubList(payload, currency);
      break;
    }
    case 'clubDetail': {
      clubDetail(payload, currency);
      break;
    }
    case 'selectClub': {
      selectClub(payload, currency);
      break;
    }
    case 'clubSignupBegin': {
      clubSignupStep(payload, currency, 'begin_club_checkout');
      break;
    }
    case 'clubSignupProduct': {
      clubSignupStep(payload, currency, 'add_club_product_info');
      break;
    }
    case 'clubSignupCustomer': {
      clubSignupStep(payload, currency, 'add_club_customer_info');
      break;
    }
    case 'clubSignupDelivery': {
      clubSignupStep(payload, currency, 'add_club_shipping_info');
      break;
    }
    case 'clubSignupPayment': {
      clubSignupStep(payload, currency, 'add_club_payment_info');
      break;
    }
    case 'clubSignupComplete': {
      clubPurchase(payload, currency);
      break;
    }
    default: {
      throw new Error(`Invalid Event ${eventName}`);
    }
  }
};

function* watchList() {
  yield takeEvery(RECORD_EVENT_REQUEST, recordEvent);
}

export default function* analyticSagas() {
  yield all([watchList()]);
}
